import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IVCallIncomingMessage, IVCallState } from './types'

const callSlice = createSlice({
    name: 'vcall',
    initialState: {
        vCallStatus: ({} as any) as string,
        vCallIncomingMessage: ({} as any) as IVCallIncomingMessage,
        vCallState: ({
            layout: 2
        } as any) as IVCallState,
        vCallPing: ({} as number),
        vCallAvailable: true
    },
    reducers: {
        vCallStateChanged: (state, action: PayloadAction<IVCallState>) => {
            state.vCallState = action.payload
        },
        vCallIncomingMessageReceived: (state, action: PayloadAction<IVCallIncomingMessage>) => {
            state.vCallIncomingMessage = action.payload
        },
        vCallSocketOpened: (state) => {
            state.vCallStatus = "connected";
        },
        vCallSocketClosed: (state) => {
            state.vCallStatus = "disconnected"
        },
        vCallWSStartConnecting: (state) => {
            state.vCallStatus = "connecting..."
        },
        vCallWSDisconnect: (state) => {
            state.vCallStatus = "disconnecting..."
        },
        vCallSendMessage: (state, action: PayloadAction<{ content: string }>) => {
            return;
        },
        vCallLayoutChanged: (state, action: PayloadAction<IVCallState>) => {
            state.vCallState.layout = action.payload.layout
        },
        vCallSetPingValue: (state, action: PayloadAction<number>) => {
            state.vCallPing = action.payload
        },
        vCallSetAvailable: (state, action: PayloadAction<boolean>) => {
            state.vCallAvailable = action.payload
        }
    },
})

export const {
    vCallStateChanged
    , vCallIncomingMessageReceived
    , vCallSocketOpened
    , vCallSocketClosed
    , vCallWSStartConnecting
    , vCallWSDisconnect
    , vCallSendMessage
    , vCallSetPingValue
    , vCallSetAvailable
} = callSlice.actions
export default callSlice.reducer


